import React from 'react'

export const formatTel = (value?: string | null): string => {
  if (!value) return '(00) 00000-0000'

  let noMask = value.replace(/\D/g, '')

  // Limita o número de caracteres a 11
  if (noMask.length > 11) {
    noMask = noMask.slice(0, 11)
  }

  const length = noMask.length

  if (length === 0) return '(00) 00000-0000'

  return noMask.replace(/^(\d{2})(\d)/, '($1) $2').replace(length === 11 ? /(\d{5})(\d)/ : /(\d{4})(\d)/, '$1-$2')
}

type Props = {
  value?: string | null
  onChange: (value: string) => void
}

export function TelInput({ value, onChange }: Props) {
  const handleTelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value
    const noMask = inputValue.replace(/\D/g, '')
    onChange(noMask)
  }

  const formattedValue = formatTel(value ?? '00000000000')

  return (
    <input
      type="text"
      inputMode="numeric"
      maxLength={15}
      pattern="\(\d{2}\) \d{4,5}-\d{4}"
      placeholder="(00) 00000-0000"
      value={formattedValue}
      onChange={handleTelChange}
      className="bg-input text-foreground max-w-28"
    />
  )
}
